module.exports = __webpack_public_path__ + "img/loan-waiting-illustration.327de2a0.png";